import ModalImage from "react-modal-image";


const Landing = () => {
    // const imageurl = "/landing.jpg";
    const steve = "/landing_steve.jpg"
    const book = "/sja_book.jpg"
    return (
        <div className="landing grid grid-cols-1 justify-items-center w-full min-w-0">
            <div style={{ fontSize: "clamp(1.75rem, 8.5vw, 4em)", color: "red", whiteSpace: "nowrap" }} className=" mt-0 text-center text-gray-400">OUTTA HIS BRAIN</div>
            <div className="w-full min-w-0 max-w-2xl bg-white border border-gray-200 rounded-lg shadow bg-transparent  dark:border-gray-700">
                <ModalImage className="w-full h-auto" small={book} large={book} alt={"Welcome"} />
            </div>
            <div style={{ fontSize: "clamp(1.75rem, 8.5vw, 4em)", color: "red", whiteSpace: "nowrap" }} className="mb-0 mt-0 text-center">INTO YOUR HANDS</div>
            <div style={{ fontSize: "clamp(1.1rem, 6.5vw, 2em)", color: "red" }} className="mb-0 mt-0 text-center max-w-full break-words">8/1/26</div>
            <div style={{ fontSize: "clamp(1.1rem, 6.5vw, 1em)", color: "red", whiteSpace: "nowrap" }} className="mb-0 mt-0 text-center max-w-full break-words">STEVEN.ATHANAS@GMAIL.COM</div>

            <div className="landing-text text-base mt-6 text-justify max-w-3xl">
                <p>Hello and welcome to Steven Jay Art where I’m inviting you to explore a little bit of my world and its creations.
                    Whether it’s visual or musical, I’ve been creating for over 6 decades, and I have no interest in stopping. Thanks
                    for taking the time to stop by.
                </p>

                {/* <p className="mt-3">
In the <span className="italic hover:not-italic">Gallery</span> you will find pieces I have made, some as far back as 1998. Watercolor, sculptures, my written 
works – it’s all represented. In the <span className="italic hover:not-italic">Shop</span> portion of the website, you’ll find pieces that are for sale. These 2 portals are not mutually 
exclusive, however. 
If there’s something in the <span className="italic hover:not-italic">Gallery</span> that you would like to have, please drop me an email and let’s discuss it.    
</p>

<p className="mt-3">
You’ll notice that I have a very keen interest in the preservation and conservation of our most precious asset: water. No one on this planet is 
exempt from the necessity of this commodity. From a small leaky faucet in a public bathroom to the negligent dumping of tons of waste into our waterways, 
we must become aware of this dilemma, and do what we can – what we must – to stop our wrongdoing. 
Our very lives and the lives of every living creature depend on it. It’s that simple.
</p> */}

                <p className="mt-3">
                    Again, I welcome you to my site and look forward to any critique/commentary/what-have-you that you may have.
                </p>

                <div className="grid grid-cols-1 justify-items-center mt-12">
                    <div className="w-full min-w-0 max-w-xl bg-white border border-gray-200 rounded-lg shadow bg-transparent  dark:border-gray-700 ">
                        <ModalImage className="w-full h-auto" small={steve} large={steve} alt={"Steven Jay"} />
                        <div className="text-lg text-center mt-1 mb-1 bg-transparent">
                            Steven Jay Athanas
                        </div>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default Landing;